export default {
    appTitle: 'RCM',
    rcmGrid: {
        invoiceNumber: 'Número da nota fiscal',
        healthcarePlanCoverage: 'PBS',
        eventNumber: 'Atendimento',
        eventDate: 'Data do atendimento',
        payerName: 'Operadora',
        agreementName: 'Convênio',
        invoiceAmount: 'Valor da conta ({currency})',
        suffix: 'R$',
        requiredSupportDocumentsCompleted: 'Documentação',
        agreementCode: 'ID do convênio',
        status: 'Status ',
        serviceTypes: 'Tipo de atendimento',
        regime: 'Regime',
        responsible: 'Responsável',
        costCenter: 'Centro de custos',
        settlementGroupId: 'Relação de envio',
    },
    rcmGridItems: {
        defaultStatus: {
            pending: 'Pendente',
        }
    },
    rcmGridTooltips: {
        multiples: 'Múltiplo',
        reassignedAccount: 'Conta faturada novamente'
    },
    documentationStatus: {
        complete: 'Completa',
        incomplete: 'Incompleta',
        ripAndCuvFilesIncomplete: 'Arquivos RIPS e CUV incompletos',
    },
    filters: {
        searchCode: 'Pesquise por Nº da nota fiscal, Atendimento, ID do Convênio, Regime ou ID do Paciente',
        invoiceNumberStatus: 'Status',
        statusHealthcarePlanCoverage: 'PBS / NPBS',
        statusDocumentation: 'Documentação',
        payer: 'Operadora',
        agreement: 'Convênio',
        minAmount: 'Valor mínimo',
        maxAmount: 'Valor máximo',
        from: 'De',
        to: 'Até',
        concurrent: 'Concorrente',
        serviceType: 'Tipo de atendimento',
        seeMoreFilters: 'Ver mais filtros',
        executorServices: 'Especialidade',
        agreementPlanTypes: 'Tipo de plano',
        invoiceSource: 'Local faturado',
        applyFilters: 'Aplicar filtros',
        currency: 'R$',
        missingSupports: 'Documentos ausentes',
        noResultsFound: 'Nenhum resultado encontrado',
        responsibleAssigned: 'Responsável atribuído',
        reassignedAccount: 'Refaturamento',
    },
    resultLabel: {
        text: 'Resultados',
        result: '({result})',
    },
    actionLabel: {
        text: 'Ações',
        selected: '({selected})'
    },
    accountsActions: {
        moveToReadyToSettlement: 'Alterar status para pronto para liquidar',
        moveToSent: 'Alterar status para enviada',
        moveToSettled: 'Alterar status para liquidada',
        disableAccounts: 'Cancelar contas',
        assignResponsible: 'Atribuir responsável',
        cleanPackageFolder: 'Excluir pasta de pacotes do FileZilla',
    },
    homeConfirmationDialog: {
        disableAccounts: {
            title: "Deseja realmente cancelar as contas selecionadas?",
            subtitle: "Informe o motivo para cancelar as contas (opcional)",
        },
        moveToSettled: {
            title: 'Deseja realmente enviar as contas selecionadas para liquidada?',
            subtitle: '',
        },
        moveToSent: {
          title: 'Deseja realmente enviar as contas selecionadas para enviada?',
          subtitle: ""
        },
        moveToPackageGenerated: {
          title: "Deseja realmente enviar as contas selecionadas para pronto para liquidar?",
          subtitle: ""
        },
        assignResponsible: {
            title: 'Atribuir responsável',
            subtitle: 'Selecione um responsável para as contas selecionadas',
            label: 'Responsável',
        },
        cleanPackageFolder: {
            title: "Deseja realmente excluir a pasta de pacotes do FileZilla?",
            subtitle: "",
          },
    },
    filtersText: {
        statusAccounts: {
            inProgress: 'Em andamento',
            invoiced: 'Faturada',
            readyToGenerate: 'Pronto para gerar',
            packageGenerated: 'Pronto para enviar',
            pendingAudit: 'Auditoria pendente',
            voided: 'Cancelada',
            error: 'Erro',
            completeAudit: 'Auditoria concluída',
            sent: 'Enviada',
            settled: 'Liquidada',
            preInvoiced: 'Pré faturado',
        },
        statusHealthcarePlanCoverage: {
            pos: 'PBS',
            notPos: 'NPBS',
            posNoPos: 'PBS / NPBS',
        },
        statusDocumentation: {
            completed: 'Completa',
            incomplete: 'Incompleta',
        },
        statusPayers: {
            nuevaEps: 'Novo Operadora',
        },
        reassignedAccount: {
          reassigned: 'Contas faturadas novamente'
        },
        statusConcurrent: 'Conta concorrente',
        mobileHeader: 'Filtros',
    },
    drawer: {
        labels: {
            accounts: 'Contas',
            agreements: 'Convênios',
            preSettlement: 'Relação de envio',
            pmisConfig: 'Configuração dos itens de cobrança',
            uploadAgreement: 'Importar convênios'
        },
        addOns: {
            accounts: {
                title: 'Lista de contas',
                placeholder: 'Pesquisar por ID',
                createdAt: 'Data de criação',
                stateAccount: 'Status',
                invoiceNumber: 'Número da nota fiscal',
                healthcarePlanCoverage: 'PBS / NPBS',
                totalInvoiceAmount: 'Número da nota fiscal',
                agreement: 'Convênio',
                locationName: 'Local de atendimento',
            }
        }
    },
    accountDetail: {
        generalInformation: {
            titlesGeneralInformation: {
                patientName: 'Paciente',
                patientId: 'ID do paciente',
                patientDocumentType: 'Tipo de identificação',
                patientDocumentNumber: 'Nº de identificação',
                eventNumber: 'Atendimento/Conta',
                eventDate: 'Data do atendimento',
                serviceType: 'Tipo de atendimento',
                insurer: 'Convênio',
                originInvoiceGroupId: 'Remessa',
                settlementNumber: 'Protocolo',
                externalId: 'Guia',
                authorizationId: 'Senha',
                regime: 'Regime',
                agreementPlanType: 'Tipo de plano',
                invoiceSource: 'Local faturado',
                invoiceNumber: 'Número da nota fiscal',
                invoiceDate: 'Data da conta',
                invoiceBranch: 'Empresa',
                createdAt: 'Data de criação da conta',
                stateAccount: 'Status',
                agreement: 'Código do convênio',
                healthcarePlanCoverage: 'PBS / NPBS',
                invoiceAmountTotal: 'Valor total',
                responsible: 'Responsável',
                reassignedInvoiceNumber: 'Conta de origem do refaturamento',
            },
            defaultInformation: {
                defaultRegime: 'Operadora',
                defaultInvoiceAmount: 'Pendente',
                defaultHealthCarePlanCoverage: 'PBS / NPBS',
            }
        }
    },
    chargeDetail: {
        patientInformation: {
            patientName: 'Paciente',
            patientId: 'ID do paciente',
            eventNumber: 'Atendimento',
            patientDocumentType: 'Tipo de identificação',
            patientDocumentNumber: 'Nº de identificação',
        },
        chargeDetail: {
            createdAt: 'Data de criação',
            healthcarePlanCoverage: 'PBS / NPBS',
            chargeCode: 'Código de cobrança',
            authorizationId: 'Código do convênio',
            invoiceable: 'Possível de cobrança',
            payer: 'Convênio',
            location: 'Empresa',
            typeOfService: 'Tipo de serviço',
            quantity: 'Quantidade',
            invoiceNumber: 'Número da nota fiscal',
            unitValue: 'Valor unitário',
            totalAmount: 'Valor total',
        },
        defaultInformation: {
            defaultInvoiceAmount: 'Pendente',
        },
        diagnosticTable: {
            diagnosticCode: 'Código do diagnóstico',
            descriptionDiagnosis: 'Descrição do diagnóstico',
            chargeDescription: 'Descrição do item de cobrança',
        }
    },
    amounts: {
        ruleMessage: 'Somente números positivos são permitidos',
        minAmount: 'Mín. {currency} {amount}',
        maxAmount: 'Máx. {currency} {amount}',
    },
    auditComplete: 'A auditoria foi concluída com sucesso',
    setReadyToGenerate: 'A conta foi marcada como pronta para gerar',
    setReadyToGenerateMultiple: 'A conta de fatura foi marcada como pronta para serem gerada. Esse processo pode levar alguns minutos; aguarde. | As contas de fatura foram marcadas como prontas para serem geradas. Esse processo pode levar alguns minutos; aguarde.',
    setPreSettlementActionMultiple: 'A conta da fatura foi colocada na fila para processamento. Esse processo pode levar alguns minutos; aguarde. | As contas de faturas foram colocadas na fila para processamento. Esse processo pode levar alguns minutos; aguarde.',
    setPreSettlementRipsValidationErrors: 'A relação de envio foi marcada com o status de erro de validação de arquivo RIPS.',
    movedToSettlement: 'As contas foram colocadas na fila para processamento. Esse processo pode levar alguns minutos; aguarde.',
    accountsAffected: 'Contas alteradas',
    setDisableAccounts: 'As contas foram canceladas com sucesso',
    assignResponsible: 'O responsável foi atribuído com sucesso',
    lastUpdate: 'Última atualização',
    errorLoadindServiceTypes: 'Erro ao obter tipos de serviço do prestador',
    errorLoadindAgreements: 'Erro ao obter os convênios do prestador',
    errorLoadindProviderSupportDocuments: 'Erro ao obter os documentos de suporte do prestador',
    cleanPackageFolder: 'A pasta de pacotes do FileZilla foi excluída com sucesso',
    errorLoadindUsers: 'Erro ao obter os usuários',
		validateAccountNotifications: {
			filter: 'Revalidar contas',
			inProgressWording: 'contas selecionadas',
			completedWording: 'contas',
			errorWording: 'contas, por favor tente novamente. ',
			status: {
				started: 'Iniciado',
				inProgress: 'Em andamento',
				completed: 'Concluído',
				error: 'Erro'
			}
		}
}